// import apiClient from "./apiClient";
// import { Category } from "./categoryService";

// interface ProductFilters {
//     category_id?: number;
//     min_price?: number;
//     max_price?: number;
//     search?: string;
//     sort_by?: string;
//     order?: "asc" | "desc";
//     inStock?: boolean;
//     onSale?: boolean;
//     tags?: string[];
//     limit?: number;
//     offset?: number;
// }

// export interface Product {
//     id: number;
//     name: string;
//     category_id: number; // ID категории
//     description: string; // Описание товара
//     price: number; // Цена товара
//     discount?: number; // Скидка (в процентах, если есть)
//     stock: number; // Количество на складе
//     sku?: string; // Уникальный идентификатор товара (артикул)
//     rating: number; // Рейтинг товара
//     reviews: number; // Количество отзывов
//     properties: Record<string, string>; // Свойства товара (объем, срок годности, тип кожи и т.д.)
//     tags: string[]; // Теги для классификации
//     is_promo: boolean; // Признак промо-акции
//     is_bestseller: boolean; // Признак бестселлера
//     images: string[]; // Список изображений товара
//     cover_image: string; // Основное изображение товара
//     category: Category; // Категория товара
//     created_at: string; // Дата добавления
//     updated_at: string; // Дата последнего обновления
// }

// interface ProductResponse {
//     products: Product[];
//     total: number; // Общее количество продуктов для пагинации
// }

// export const fetchProducts = async (filters: ProductFilters): Promise<ProductResponse> => {
//     try {
//         const response = await apiClient.get<ProductResponse>("/api/products", {
//             params: filters,
//         });
//         return response.data;
//     } catch (error) {
//         console.error("Ошибка при запросе продуктов:", error);
//         throw error;
//     }
// };

// export const fetchProductById = async (id: number): Promise<Product> => {
//     try {
//         const response = await apiClient.get<Product>(`/api/products/${id}`);
//         return response.data;
//     } catch (error) {
//         console.error(`Ошибка при запросе продукта с ID ${id}:`, error);
//         throw error;
//     }
// };

import apiClient from "./apiClient";
import { Product, ProductFilters, ProductPayload } from "../types";
import { ImageType } from "../components/product/ImageUpload";
// Убрали старую логику остатков по городам - теперь используется система складов

interface ProductsResponse {
  products?: Product[];
  total: number;
}

interface ProductResponse {
  product: Product;
  message: string;
}

export const fetchProducts = async (filters: ProductFilters): Promise<ProductsResponse> => {
  // Убрали старую логику остатков по городам - теперь используется система складов
  const response = await apiClient.get<ProductsResponse>("/api/products", {
    params: filters,
  });
  return response.data;
};

export const fetchProductById = async (id: number): Promise<Product> => {
  const response = await apiClient.get<Product>(`/api/products/${id}`);
  return response.data;
};

export const createProduct = async (productData: ProductPayload): Promise<ProductResponse> => {
  const response = await apiClient.post<ProductResponse>("/api/products", productData);
  return response.data;
};

export const updateProduct = async (id: number, productData: Product): Promise<{ product: Product }> => {
  const response = await apiClient.put(`/api/products/${id}`, productData);
  return response.data;
};

export const deleteProduct = async (id: number) => {
  await apiClient.delete(`/api/products/${id}`);
};

export const uploadProductImages = async (productId: number, files: File[], productName: string): Promise<void> => {
  const formData = new FormData();

  files.forEach((file, index) => {
    const fileName = `${productId}_${productName}_${index + 1}${file.name.substring(file.name.lastIndexOf('.'))}`;
    const renamedFile = new File([file], fileName, { type: file.type });
    formData.append('files', renamedFile);
  });

  // Первое изображение будет обложкой
  formData.append('cover', `${productId}_${productName}_1${files[0].name.substring(files[0].name.lastIndexOf('.'))}`);

  await apiClient.post(`/api/products/${productId}/images`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// export const createProductWithImages = async (
//   productData: ProductPayload,
//   files: File[],
//   coverIndex: number
// ): Promise<void> => {
//   const formData = new FormData();

//   const preparedData = {
//     ...productData,
//     ingredients_ids: (productData.ingredients_ids && productData.ingredients_ids.length > 0) ? productData.ingredients_ids : null,
//     skin_types_ids: (productData.skin_types_ids && productData.skin_types_ids.length > 0) ? productData.skin_types_ids : null,
//     problems_ids: (productData.problems_ids && productData.problems_ids.length > 0) ? productData.problems_ids : null,
//     properties: Object.keys(productData.properties).length > 0 ? productData.properties : null,
//   };
//   formData.append("product", JSON.stringify(preparedData));


//   files.forEach((file, index) => {
//     const fileName = `${productData.name}_${index + 1}${file.name.substring(file.name.lastIndexOf("."))}`;
//     const renamedFile = new File([file], fileName, { type: file.type });
//     formData.append("files", renamedFile);
//   });

//   // Установка обложки
//   const coverFileName = `${productData.name}_${coverIndex + 1}${files[coverIndex].name.substring(files[coverIndex].name.lastIndexOf("."))}`;
//   formData.append("cover", coverFileName);

//   // Отправка запроса
//   await apiClient.post("/api/products/complete", formData, {
//     headers: { "Content-Type": "multipart/form-data" },
//   });
// };

export const createProductWithImages = async (
  productData: ProductPayload,
  files: ImageType[],
  coverIndex: number
): Promise<{ message: string; product: { name: string }; cover_image: string }> => {
  const formData = new FormData();

  // Убираем # из имени продукта
  const sanitizedProductName = productData.name.replace(/#/g, "");

  const preparedData: ProductPayload = {
    ...productData,
    category_id: Number(productData.category_id),
    brand_id: Number(productData.brand_id),
    skin_types_ids: Array.isArray(productData.skin_types_ids) ? productData.skin_types_ids.map(Number) : [],
    ingredients_ids: Array.isArray(productData.ingredients_ids) ? productData.ingredients_ids.map(Number) : [],
    problems_ids: Array.isArray(productData.problems_ids) ? productData.problems_ids.map(Number) : [],
    properties: productData.properties || {},
  };
  formData.append("product", JSON.stringify(preparedData));

  const fileList = files.filter((file): file is File => file instanceof File);

  fileList.forEach((file, index) => {
    const fileName = `${sanitizedProductName}_${index + 1}${file.name.substring(file.name.lastIndexOf("."))}`;
    const renamedFile = new File([file], fileName, { type: file.type });
    formData.append("files", renamedFile);
  });

  const coverFileName = fileList.length > coverIndex
    ? `${sanitizedProductName}_${coverIndex + 1}${fileList[coverIndex].name.substring(fileList[coverIndex].name.lastIndexOf("."))}`
    : "";
  formData.append("cover", coverFileName);

  const response = await apiClient.post("/api/products/complete", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return response.data;
};

export const updateProductWithImages = async (
  productData: ProductPayload,
  files: ImageType[],
  coverIndex: number
): Promise<{ message: string; product: { name: string }; cover_image: string }> => {
  const formData = new FormData();

  // Убираем # из имени продукта
  const sanitizedProductName = productData.name.replace(/#/g, "");

  const preparedData: ProductPayload = {
    ...productData,
    category_id: Number(productData.category_id),
    brand_id: Number(productData.brand_id),
    skin_types_ids: Array.isArray(productData.skin_types_ids) ? productData.skin_types_ids.map(Number) : [],
    ingredients_ids: Array.isArray(productData.ingredients_ids) ? productData.ingredients_ids.map(Number) : [],
    problems_ids: Array.isArray(productData.problems_ids) ? productData.problems_ids.map(Number) : [],
    properties: productData.properties || {},
  };
  
  formData.append("product", JSON.stringify(preparedData));

  files.forEach((file, index) => {
    if (file instanceof File) {
      const extension = file.name.substring(file.name.lastIndexOf("."));
      const fileName = `${sanitizedProductName}_${index + 1}${extension}`;
      const renamedFile = new File([file], fileName, { type: file.type });
      formData.append(`file_${index}`, renamedFile);
    }
  });

  // Бэкенд ожидает индекс слота обложки (0, 1, 2...), не имя файла
  formData.append("cover", String(coverIndex));
  
  const response = await apiClient.put("/api/products/update-with-images", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return response.data;
};